import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import { formatFloat, getCurrencySymbol, tr } from 'mmfintech-commons'

import './ExchangeMaxAvailable.scss'

interface ExchangeMaxAvailableProps {
  amount: number
  currencyCode: string
  dataTest?: string
}

export const ExchangeMaxAvailable = ({ amount, currencyCode, dataTest }: ExchangeMaxAvailableProps) => {
  const { getCurrencyPrecision } = useCurrencies()

  return (
    <div className='exchange-max' data-test={dataTest}>
      <span className='exchange-max-label'>
        {tr('FRONTEND.MONEY_INPUT.LABEL_MAX_AVAILABLE', 'Max available before fees')}
      </span>
      <span className='exchange-max-value'>
        {`${getCurrencySymbol(formatCurrencyForDisplay(currencyCode))} ${formatFloat(amount, getCurrencyPrecision(currencyCode))}`}
      </span>
    </div>
  )
}
